import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';

import MessageFilter from './Pages/MessageFilter';

const MessageFilterRoutes = () => {
    return (
        <Fragment>
            <Route path="/filter" exact component={MessageFilter} />
        </Fragment>
    )
};

export default MessageFilterRoutes;
